import {Module} from "../models/module.model";
import {ExplanationType} from "../enums/explanation-types";
import {RespTypes} from "../enums/resp-types";
import {SmallTexts} from "../enums/small-texts";
import {ScreenTypes} from "../enums/screen-types";
import {QstReferences} from "./qst-references";
import {EndReferences, ExplReferences, IntroReferences} from "./other-screens-references";
import {Section1} from "./texts-section-01";
import {Section2} from "./texts-section-02";
import {Section3} from "./texts-section-03";
import {Section4} from "./texts-section-04";
import {Section5} from "./texts-section-05";
import {Section6} from "./texts-section-06";

// Data Screens by Module
export const ModulesScreens = [
  { // Section 1
    module_id: 1,
    module_uuid: "f3ea5105-1688-4b2c-a062-691924de46aa",
    screens: [
      {
        type: ScreenTypes.Intro,
        ref: IntroReferences.RefSection1Intro01,
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection1Qst01,
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection1Qst02,
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection1Qst03,
        special_class: 'special-radio-ol',
        annexe_after_question_label: 'one_answer_possible'
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection1Qst04,
        annexe_after_question_label: 'many_answers_possible'
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection1Qst05,
        annexe_after_question_label: 'many_answers_possible'
      },
      {
        type: ScreenTypes.End,
        ref: EndReferences.RefSection1End01,
      },
    ],
  },
  { // Section 2
    module_id: 3,
    module_uuid: "531272fc-2c7b-4eac-a76b-76778cf81f8c",
    screens: [
      {
        type: ScreenTypes.Intro,
        ref: IntroReferences.RefSection2Intro01,
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl01,
        annexes: Section2.ExplanationTexts.annexes_expl01,
        small_texts: {
          1: SmallTexts.PriseEnCharge
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section2.ExplanationTexts.title_expl01,
          text: Section2.ExplanationTexts.text_expl01,
          image: Section2.ExplanationTexts.image_expl01,
          asterisks: Section2.ExplanationTexts.asterisks_expl01,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl02,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.Chuv
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section2.ExplanationTexts.title_expl02,
          text: Section2.ExplanationTexts.text_expl02,
          image: Section2.ExplanationTexts.image_expl02,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl03,
        has_button_previous: true,
        annexes: Section2.ExplanationTexts.annexes_expl03,
        small_texts: {
          1: SmallTexts.Snitem,
          2: SmallTexts.Carrera,
        },
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section2.ExplanationTexts.title_expl03,
          text: Section2.ExplanationTexts.text_expl03,
          list_title: Section2.ExplanationTexts.list_title_expl03,
          text_flex_columns: Section2.ExplanationTexts.text_flex_columns_expl03,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl04,//'02sec04e',
        has_button_previous: true,
        explanation: {
          type: ExplanationType.ButtonsPopUp,
          title: Section2.ExplanationTexts.title_expl04,
          text: Section2.ExplanationTexts.text_expl04,
          list_title: Section2.ExplanationTexts.list_title_expl04,
          list_buttons: Section2.ExplanationTexts.list_buttons_expl04,
        },
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection2Qst01,
        has_button_previous: false,
        has_button_try_again: true,
        annexe_after_question_label: 'drop_zone_single_text_1',
        annexe_in_drop_zone: 'drop_zone_single_text_DZ_1',
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl05,
        small_texts: {
          1: SmallTexts.Amici
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section2.ExplanationTexts.title_expl05,
          image: Section2.ExplanationTexts.image_expl05,
          text: Section2.ExplanationTexts.text_expl05,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl06,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.Amici,
          2: SmallTexts.Chuv
        },
        annexes: Section2.ExplanationTexts.annexes_expl06,
        explanation: {
          type: ExplanationType.ButtonsPopUp,
          title: Section2.ExplanationTexts.title_expl06,
          text: Section2.ExplanationTexts.text_expl06,
          list_title: "",
          list_buttons: Section2.ExplanationTexts.list_buttons_expl06,
        },
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection2Qst02,
        has_button_previous: false,
        has_button_try_again: true,
        annexe_after_question_label: "drag_and_drop_in_order",
        annexe_in_drop_zone: "step",
        small_texts: {
          1: SmallTexts.Snitem,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl07,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.Chuv,
          2: SmallTexts.Has
        },
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section2.ExplanationTexts.title_expl07,
          text: Section2.ExplanationTexts.text_expl07,
          text_flex_columns: Section2.ExplanationTexts.text_flex_columns_expl07,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl08,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.Chuv
        },
        annexes: Section2.ExplanationTexts.annexes_expl08,
        explanation: {
          type: ExplanationType.ImageFixePopUp,
          title: Section2.ExplanationTexts.title_expl08,
          image: Section2.ExplanationTexts.image_expl08,
          text: Section2.ExplanationTexts.text_expl08,
          list_buttons: Section2.ExplanationTexts.list_buttons_expl08,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl09,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.Snitem,
          2: SmallTexts.WorldUnion
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section2.ExplanationTexts.title_expl09,
          text: Section2.ExplanationTexts.text_expl09,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl10,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.NumSpecLohmann,
          2: SmallTexts.NicholsEWoundAssess
        },
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section2.ExplanationTexts.title_expl10,
          text: Section2.ExplanationTexts.text_expl10,
          text_flex_columns: Section2.ExplanationTexts.text_flex_columns_expl10,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl11,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.WorldUnion,
          //2: SmallTexts.Graphe2
        },
        annexes: Section2.ExplanationTexts.annexes_expl11,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section2.ExplanationTexts.title_expl11,
          text: Section2.ExplanationTexts.text_expl11,
        }
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl12,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.EffectAirDrying,
          2: SmallTexts.Amici
        },
        explanation: {
          type: ExplanationType.ButtonsPopUp,
          title: Section2.ExplanationTexts.title_expl12,
          text: Section2.ExplanationTexts.text_expl12,
          list_buttons: Section2.ExplanationTexts.list_buttons_expl12,
        }
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection2Expl13,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.SenetP,
          2: SmallTexts.Sfar
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section2.ExplanationTexts.title_expl13,
          text: Section2.ExplanationTexts.text_expl13,
        }
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection2Qst03,
        annexe_after_question_label: 'one_answer_possible'
      },
      {
        type: ScreenTypes.End,
        ref: EndReferences.RefSection2End01,
        annexes: Section2.EndTexts.annexes_end01,
      },
    ],
  },
  { // Section 3
    module_id: 5,
    module_uuid: "7b0fe7ad-72bf-481c-8cc4-ecc59f7cda33",
    screens: [
      {
        type: ScreenTypes.Intro,
        ref: IntroReferences.RefSection3Intro01,
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection3Qst01,
        annexe_after_question_label: "drag_and_drop_in_order_2",
        small_texts: {
          1: SmallTexts.Has,
        }
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl01,
        small_texts: {
          1: SmallTexts.Codims,
          2: SmallTexts.ColauH,
          //3: SmallTexts.Photo216489892,
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section3.ExplanationTexts.title_expl01,
          text: Section3.ExplanationTexts.text_expl01,
          image: Section3.ExplanationTexts.image_expl01,//03sec01e_img.jpg
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl02,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.SenetP,
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section3.ExplanationTexts.title_expl02,
          text: Section3.ExplanationTexts.text_expl02,
          image: Section3.ExplanationTexts.image_expl02,//03sec01e_img.jpg
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl03,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.Chru,
          2: SmallTexts.Has,
          3: SmallTexts.Snitem,
          4: SmallTexts.AssuranceMaladie,
          5: SmallTexts.PikovskiD,
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section3.ExplanationTexts.title_expl03,
          text: Section3.ExplanationTexts.text_expl03,
          asterisks: Section3.ExplanationTexts.asterisks_expl03,
        },
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection3Qst02,
        annexe_after_question_label: 'many_answers_possible',
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl04,
        small_texts: {
          1: SmallTexts.Has
        },
        annexes: Section3.ExplanationTexts.annexes_expl04,
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section3.ExplanationTexts.title_expl04,
          text: Section3.ExplanationTexts.text_expl04,
          text_flex_columns: Section3.ExplanationTexts.text_flex_columns_expl04,
        },
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection3Qst03,
        annexe_after_question_label: 'one_answer_possible',
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl05,
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section3.ExplanationTexts.title_expl05,
          text: Section3.ExplanationTexts.text_expl05,
          asterisks: Section3.ExplanationTexts.asterisks_expl05,
        }
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl06,
        has_button_previous: true,
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section3.ExplanationTexts.title_expl06,
          text: Section3.ExplanationTexts.text_expl06,
          asterisks: Section3.ExplanationTexts.asterisks_expl06,
        }
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl07,
        has_button_previous: true,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section3.ExplanationTexts.title_expl07,
          text: Section3.ExplanationTexts.text_expl07,
          image: Section3.ExplanationTexts.image_expl07,
          asterisks: Section3.ExplanationTexts.asterisks_expl07,
          list_buttons: Section3.ExplanationTexts.list_buttons_expl07,
        }
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection3Qst04,
        annexe_after_question_label: 'drag_and_drop_in_order_3',
        annexes: Section3.ExplanationTexts.annexes_qst04,
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl08,
        has_button_previous: true,
        annexes: Section3.ExplanationTexts.annexes_expl08,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section3.ExplanationTexts.title_expl08,
          text: Section3.ExplanationTexts.text_expl08,
          image: Section3.ExplanationTexts.image_expl08,
        }
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl09,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.NoticesUtilisation
        },
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section3.ExplanationTexts.title_expl09,
          text: Section3.ExplanationTexts.text_expl09,
          text_flex_columns: Section3.ExplanationTexts.text_flex_columns_expl09,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl10,
        has_button_previous: true,
        annexes: Section3.ExplanationTexts.annexes_expl10,
        small_texts: {
          1: SmallTexts.DFC2020036,
          2: SmallTexts.DFC2022051,
          3: SmallTexts.DFC2022053,
          4: SmallTexts.DFC2022041,
          5: SmallTexts.DFC2022046,
          6: SmallTexts.DFC2022049,
          7: SmallTexts.DFC2022054,
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section3.ExplanationTexts.title_expl10,
          text: Section3.ExplanationTexts.text_expl10,
          image: Section3.ExplanationTexts.image_expl10,
          asterisks: Section3.ExplanationTexts.asterisks_expl10,
        }
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl11,
        has_button_previous: true,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section3.ExplanationTexts.title_expl11,
          text: Section3.ExplanationTexts.text_expl11,
          image: Section3.ExplanationTexts.image_expl11,
          asterisks: Section3.ExplanationTexts.asterisks_expl11,
          list_buttons: Section3.ExplanationTexts.list_buttons_expl11,
        }
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl12,
        has_button_previous: true,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section3.ExplanationTexts.title_expl12,
          text: Section3.ExplanationTexts.text_expl12,
          image: Section3.ExplanationTexts.image_expl12,
          asterisks: Section3.ExplanationTexts.asterisks_expl12,
          list_buttons: Section3.ExplanationTexts.list_buttons_expl12,
        }
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection3Expl13,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.DFC2019125,
          2: SmallTexts.DFC2021112,
          3: SmallTexts.NoticeUtilisation + ' ' + SmallTexts.VliwasorbSensitive,
          4: SmallTexts.DFC2019066,
          5: SmallTexts.DFC2019070,
          6: SmallTexts.DFC2021119,
          7: SmallTexts.DFC2024062,
          8: SmallTexts.DFC2021123,
          9: SmallTexts.NoticeUtilisation + ' ' + SmallTexts.VliwasorbPro, //SmallTexts.DFC2021108,
          10: SmallTexts.DFC2021108,
          11: SmallTexts.DFC2024063,
          12: SmallTexts.DFC2019068,
          13: SmallTexts.DFC2021121,
          14: SmallTexts.DFC2021118 + ', ' + SmallTexts.DFC2024154,
        },
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section3.ExplanationTexts.title_expl13,
          text: Section3.ExplanationTexts.text_expl13,
          text_flex_columns: Section3.ExplanationTexts.text_flex_columns_expl13,
          asterisks: Section3.ExplanationTexts.asterisks_expl13,
        }
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection3Qst05,
        annexe_after_question_label: 'one_answer_possible',
        annexes: Section3.ExplanationTexts.annexes_qst05,
        //asterisks:Section3.ExplanationTexts.asterisks_qst05,
      },
      {
        type: ScreenTypes.End,
        ref: EndReferences.RefSection3End01,
        special_class: 'small text-start',
        annexes: Section3.EndTexts.annexes_end01,
      },
    ],
  },
  { // Section 4
    module_id: 6,
    module_uuid: "347f9421-29c3-4789-b9f8-ca034edea9f6",
    screens: [
      {
        type: ScreenTypes.Intro,
        ref: IntroReferences.RefSection4Intro01,
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection4Expl01,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section4.ExplanationTexts.title_expl01,
          text: Section4.ExplanationTexts.text_expl01,
          image: Section4.ExplanationTexts.image_expl01,
        },
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection4Qst01,
        annexe_after_question_label: 'one_answer_possible',
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection4Qst02,
        annexe_after_question_label: 'many_answers_possible',
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection4Expl02,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section4.ExplanationTexts.title_expl02,
          text: Section4.ExplanationTexts.text_expl02,
          image: Section4.ExplanationTexts.image_expl02,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection4Expl03,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.AssuranceMaladie,
          2: SmallTexts.PikovskiD,
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section4.ExplanationTexts.title_expl03,
          text: Section4.ExplanationTexts.text_expl03,
          image: Section4.ExplanationTexts.image_expl03,
          asterisks: Section4.ExplanationTexts.asterisks_expl03,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection4Expl04,
        has_button_previous: true,
        explanation: {
          type: ExplanationType.ImageFixePopUp,
          title: Section4.ExplanationTexts.title_expl04,
          image: Section4.ExplanationTexts.image_expl04,
          text: Section4.ExplanationTexts.text_expl04,
          list_buttons: Section4.ExplanationTexts.list_buttons_expl04,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection4Expl05,
        has_button_previous: true,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section4.ExplanationTexts.title_expl05,
          image: Section4.ExplanationTexts.image_expl05,
          text: Section4.ExplanationTexts.text_expl05,
        },
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection4Qst03,
        annexe_after_question_label: 'one_answer_possible',
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection4Expl06,
        small_texts: {
          1: SmallTexts.Has,
          2: SmallTexts.Chru,
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section4.ExplanationTexts.title_expl06,
          text: Section4.ExplanationTexts.text_expl06,
          list_buttons: Section4.ExplanationTexts.list_buttons_expl06,
        }
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection4Expl07,
        has_button_previous: true,
        annexes: Section4.ExplanationTexts.annexes_expl07,
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section4.ExplanationTexts.title_expl07,
          text: Section4.ExplanationTexts.text_expl07,
        },
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection4Qst04,
        annexe_after_question_label: 'one_answer_possible',
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection4Expl08,
        annexes: Section4.ExplanationTexts.annexes_expl08,
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section4.ExplanationTexts.title_expl08,
          text: Section4.ExplanationTexts.text_expl08,
        },
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection4Qst05,
        //has_button_try_again: true,
        annexe_after_question_label: 'drop_zone_single_text_2',
        annexe_in_drop_zone: 'drop_zone_single_text_DZ_2',
        annexes: Section4.ExplanationTexts.annexes_q05,
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection4Expl09,
        small_texts: {
          1: SmallTexts.NoticeUtilisation,
          2: SmallTexts.DFC2022050,
          3: SmallTexts.DFC2022051,
        },
        annexes: Section4.ExplanationTexts.annexes_expl09,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section4.ExplanationTexts.title_expl09,
          text: Section4.ExplanationTexts.text_expl09,
          //image: Section4.ExplanationTexts.image_expl09,
          asterisks: Section4.ExplanationTexts.asterisks_expl09,
        },
      },
      {
        type: ScreenTypes.End,
        ref: EndReferences.RefSection4End01,
        special_class: 'small text-start',
        annexes: Section4.EndTexts.annexes_end01,
      },
    ],
  },
  { // Section 5
    module_id: 7,
    module_uuid: "6ddab3d7-2b0a-48db-9628-b513834b0087",
    screens: [
      {
        type: ScreenTypes.Intro,
        ref: IntroReferences.RefSection5Intro01,
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl01,
        small_texts: {
          1: SmallTexts.WoundsUk,
          2: SmallTexts.Snitem,
        },
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section5.ExplanationTexts.title_expl01,
          text: Section5.ExplanationTexts.text_expl01,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl02,
        small_texts: {
          1: SmallTexts.LomigLeBihan,
          2: SmallTexts.HopitalParisSaintJoseph,
        },
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section5.ExplanationTexts.title_expl02,
          text: Section5.ExplanationTexts.text_expl02,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl03,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.HospicesCivilsLyon,
          2: SmallTexts.LomigLeBihan,
          3: SmallTexts.HasPriseEnCharge,
          4: SmallTexts.OuvryPierre,
        },
        annexes: Section5.ExplanationTexts.annexes_expl03,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section5.ExplanationTexts.title_expl03,
          text: Section5.ExplanationTexts.text_expl03,
          image: Section5.ExplanationTexts.image_expl03,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl04,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.HospicesCivilsLyon,
          2: SmallTexts.LomigLeBihan,
          3: SmallTexts.HasPriseEnCharge
        },
        annexes: Section5.ExplanationTexts.annexes_expl04,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section5.ExplanationTexts.title_expl04,
          text: Section5.ExplanationTexts.text_expl04,
          image: Section5.ExplanationTexts.image_expl04,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl05,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.HospicesCivilsLyon,
          2: SmallTexts.UlcereJambe,
        },
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section5.ExplanationTexts.title_expl05,
          text: Section5.ExplanationTexts.text_expl05,
        },
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection5Qst01,
        annexe_after_question_label: 'drag_and_drop_in_order_4',
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl06,
        small_texts: {
          1: SmallTexts.MalacarneS,
          2: SmallTexts.WoundsUk,
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section5.ExplanationTexts.title_expl06,
          text: Section5.ExplanationTexts.text_expl06,
          image: Section5.ExplanationTexts.image_expl06,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl07,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.MalacarneS,
          2: SmallTexts.AkkusG,
        },
        annexes: Section5.ExplanationTexts.annexes_expl07,
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section5.ExplanationTexts.title_expl07,
          text_flex_columns: Section5.ExplanationTexts.text_flex_columns_expl07,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl08,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.MalacarneS,
          2: SmallTexts.WoundsUk,
        },
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section5.ExplanationTexts.title_expl08,
          text: Section5.ExplanationTexts.text_expl08,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl09,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.WoundsUk,
        },
        explanation: {
          type: ExplanationType.FlexColsTexte,
          title: Section5.ExplanationTexts.title_expl09,
          text: Section5.ExplanationTexts.text_expl09,
        },
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection5Qst02,
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl10,
        small_texts: {
          1: SmallTexts.AMPlaiesChroniques,
          2: SmallTexts.HospicesCivilsLyon,
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          image: Section5.ExplanationTexts.image_expl10,
          title: Section5.ExplanationTexts.title_expl10,
          text: Section5.ExplanationTexts.text_expl10,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl11,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.AMPlaiesChroniques,
          2: SmallTexts.LomigLeBihan,
          3: SmallTexts.HasBonUsage,
          4: SmallTexts.WongIky,
          5: SmallTexts.HasPriseEnCharge,
        },
        annexes: Section5.ExplanationTexts.annexes_expl11,
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section5.ExplanationTexts.title_expl11,
          text: Section5.ExplanationTexts.text_expl11,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl12,
        has_button_previous: true,
        small_texts: {
          1: SmallTexts.MalacarneS,
          2: SmallTexts.AMPlaiesChroniques,
        },
        explanation: {
          type: ExplanationType.ImageEtTexte,
          title: Section5.ExplanationTexts.title_expl12,
          text: Section5.ExplanationTexts.text_expl12,
        },
      },
      {
        type: ScreenTypes.Explanation,
        ref: ExplReferences.RefSection5Expl13,
        has_button_previous: true,
        explanation: {
          type: ExplanationType.ButtonsPopUp,
          title: Section5.ExplanationTexts.title_expl13,
          text: Section5.ExplanationTexts.text_expl13,
          list_buttons: Section5.ExplanationTexts.list_buttons_expl13,
        },
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection5Qst03,
        annexes: Section5.ExplanationTexts.annexes_q03,
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection5Qst04,
      },
      {
        type: ScreenTypes.End,
        ref: EndReferences.RefSection5End01,
      }
    ]
  },
  { // Section 6
    module_id: 8,
    module_uuid: "1d24ef4f-4f89-41f2-9b45-7c2c298259ba",
    screens: [
      {
        type: ScreenTypes.Intro,
        ref: IntroReferences.RefSection6Intro01,
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection6Qst01,
        annexe_after_question_label: 'one_answer_possible',
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection6Qst02,
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection6Qst03,
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection6Qst04,
        annexe_after_question_label: 'one_answer_possible',
      },
      {
        type: ScreenTypes.Question,
        ref: QstReferences.RefSection6Qst05,
      },
      {
        type: ScreenTypes.End,
        ref: EndReferences.RefSection6End01,
      },
      {
        type: ScreenTypes.End,
        ref: EndReferences.RefSection6End02,
        special_class: 'small text-start',
        annexes: Section6.EndTexts.annexes_end02,
      }
    ]
  }
];

// Data Responses by Qst Ref
export const DataResponses = [
  {
    ref: QstReferences.RefSection1Qst01,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.Snitem
    },
    is_correct: {
      title: Section1.Responses.title_correct_q01, //title_correct_01sec01q,
      text: Section1.Responses.text_q01,
    },
    is_not_correct: {
      title: Section1.Responses.title_not_correct_q01,
      text: Section1.Responses.text_q01,
    }
  },
  {
    ref: QstReferences.RefSection1Qst02,
    type: RespTypes.ImageLeftAndTextRight,
    small_texts: {
      1: SmallTexts.Amici
    },
    is_correct: {
      title: Section1.Responses.title_correct_q02,
      text: Section1.Responses.text_q02,
      image: Section1.Responses.image_q02,
    },
    is_not_correct: {
      title: Section1.Responses.title_not_correct_q02,
      text: Section1.Responses.text_q02,
      image: Section1.Responses.image_q02,
    }
  },
  {
    ref: QstReferences.RefSection1Qst03,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.Has
    },
    is_correct: {
      title: Section1.Responses.title_correct_q03,
      text: Section1.Responses.text_q03,
      image: Section1.Responses.image_q03,
    },
    is_not_correct: {
      title: Section1.Responses.title_not_correct_q03,
      text: Section1.Responses.text_q03,
      image: Section1.Responses.image_q03,
    }
  },
  {
    ref: QstReferences.RefSection1Qst04,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.Amici
    },
    is_correct: {
      title: Section1.Responses.title_correct_q04,
      text: Section1.Responses.text_q04,
    },
    is_not_correct: {
      title: Section1.Responses.title_not_correct_q04,
      text: Section1.Responses.text_q04,
    }
  },
  {
    ref: QstReferences.RefSection1Qst05,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.Chru,
      2: SmallTexts.Has,
      3: SmallTexts.Snitem,
    },
    is_correct: {
      title: Section1.Responses.title_correct_q05,
      text: Section1.Responses.text_q05,
    },
    is_not_correct: {
      title: Section1.Responses.title_not_correct_q05,
      text: Section1.Responses.text_q05,
    }
  },
  {
    ref: QstReferences.RefSection2Qst01,
    type: RespTypes.Default,
    is_correct: {
      title: Section2.Responses.title_correct_q01,
      text: Section2.Responses.text_correct_q01,
    },
    is_not_correct: {
      title: Section2.Responses.title_not_correct_q01,
      text: Section2.Responses.text_not_correct_q01,
    }
  },
  {
    ref: QstReferences.RefSection2Qst02,
    type: RespTypes.ImagesPlusPopup,
    other_datas: Section2.Responses.texts_explication_q02,
    small_texts: {
      1: SmallTexts.Snitem,
      2: SmallTexts.Has
    },
    annexes: Section2.Responses.annexes_q02,
    is_correct: {
      title: Section2.Responses.title_correct_q02,
      text: Section2.Responses.text_q02,
    },
    is_not_correct: {
      title: Section2.Responses.title_not_correct_q02,
      text: Section2.Responses.text_q02,
    },
  },
  {
    ref: QstReferences.RefSection2Qst03,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.WorldUnion
    },
    is_correct: {
      title: Section2.Responses.title_correct_q03, //title_correct_01sec01q,
      text: Section2.Responses.text_q03,
    },
    is_not_correct: {
      title: Section2.Responses.title_not_correct_q03,
      text: Section2.Responses.text_q03,
    }
  },
  {
    ref: QstReferences.RefSection3Qst01,
    type: RespTypes.ImageLeftAndTextRight,
    small_texts: {
      1: SmallTexts.Has,
      2: SmallTexts.SenetP,
    },
    is_correct: {
      title: Section3.Responses.title_correct_q01,
      text: Section3.Responses.text_q01,
      image: Section3.Responses.image_q01,
    },
    is_not_correct: {
      title: Section3.Responses.title_not_correct_q01,
      text: Section3.Responses.text_q01,
      image: Section3.Responses.image_q01,
    }
  },
  {
    ref: QstReferences.RefSection3Qst02,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.WorldUnion
    },
    is_correct: {
      title: Section3.Responses.title_correct_q02,
      text: Section3.Responses.text_correct_q02,
    },
    is_not_correct: {
      title: Section3.Responses.title_not_correct_q02,
      text: Section3.Responses.text_not_correct_q02,
    }
  },
  {
    ref: QstReferences.RefSection3Qst03,
    type: RespTypes.Default,
    is_correct: {
      title: Section3.Responses.title_correct_q03,
      text: Section3.Responses.text_q03,
    },
    is_not_correct: {
      title: Section3.Responses.title_not_correct_q03,
      text: Section3.Responses.text_q03,
    }
  },
  {
    ref: QstReferences.RefSection3Qst04,
    type: RespTypes.Default,
    annexes: Section3.ExplanationTexts.annexes_qst04,
    is_correct: {
      title: Section3.Responses.title_correct_q04,
      text: Section3.Responses.text_correct_q04,
      image: Section3.Responses.image_q04,
    },
    is_not_correct: {
      title: Section3.Responses.title_not_correct_q04,
      text: Section3.Responses.text_not_correct_q04,
      image: Section3.Responses.image_q04,
    }
  },
  {
    ref: QstReferences.RefSection3Qst05,
    type: RespTypes.ImageLeftAndTextRight,
    annexes: Section3.Responses.annexes_q05,
    is_correct: {
      title: Section3.Responses.title_correct_q05,
      text: Section3.Responses.text_q05,
      image: Section3.Responses.image_q05,
    },
    is_not_correct: {
      title: Section3.Responses.title_not_correct_q05,
      text: Section3.Responses.text_q05,
      image: Section3.Responses.image_q05,
    }
  },
  {
    ref: QstReferences.RefSection4Qst01,
    type: RespTypes.ImageLeftAndTextRight,
    is_correct: {
      title: Section4.Responses.title_correct_q01,
      text: Section4.Responses.text_q01,
      image: Section4.Responses.image_q01,
    },
    is_not_correct: {
      title: Section4.Responses.title_not_correct_q01,
      text: Section4.Responses.text_q01,
      image: Section4.Responses.image_q01,
    }
  },
  {
    ref: QstReferences.RefSection4Qst02,
    type: RespTypes.ImageLeftAndTextRight,
    small_texts: {
      1: SmallTexts.Chru,
      2: SmallTexts.Has,
      3: SmallTexts.Snitem,
    },
    is_correct: {
      title: Section4.Responses.title_correct_q02,
      text: Section4.Responses.text_correct_q02,
    },
    is_not_correct: {
      title: Section4.Responses.title_not_correct_q02,
      text: Section4.Responses.text_not_correct_q02,
    }
  },
  {
    ref: QstReferences.RefSection4Qst03,
    type: RespTypes.Default,
    is_correct: {
      title: Section4.Responses.title_correct_q03
    },
    is_not_correct: {
      title: Section4.Responses.title_not_correct_q03,
      text: Section4.Responses.text_q03,
    }
  },
  {
    ref: QstReferences.RefSection4Qst04,
    type: RespTypes.Default,
    is_correct: {
      title: Section4.Responses.title_correct_q04
    },
    is_not_correct: {
      title: Section4.Responses.title_not_correct_q04,
      text: Section4.Responses.text_q04,
    }
  },
  {
    ref: QstReferences.RefSection4Qst05,
    type: RespTypes.Default,
    annexes: Section4.ExplanationTexts.annexes_q05,
    is_correct: {
      title: Section4.Responses.title_correct_q05
    },
    is_not_correct: {
      title: Section4.Responses.title_not_correct_q05,
      text: Section4.Responses.text_q05,
    }
  },
  {
    ref: QstReferences.RefSection5Qst01,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.HospicesCivilsLyon,
      2: SmallTexts.LomigLeBihan,
      3: SmallTexts.WoundsUk,
    },
    is_correct: {
      title: Section5.Responses.title_correct_q01,
      text: Section5.Responses.text_q01,
      additional_text_title: Section5.Responses.additional_text_title_q01,
    },
    is_not_correct: {
      title: Section5.Responses.title_not_correct_q01,
      text: Section5.Responses.text_q01,
      additional_text_title: Section5.Responses.additional_text_title_q01,
    }
  },
  {
    ref: QstReferences.RefSection5Qst02,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.MalacarneS,
      2: SmallTexts.WoundsUk,
    },
    is_correct: {
      title: Section5.Responses.title_correct_q02,
      text: Section5.Responses.text_q02,
    },
    is_not_correct: {
      title: Section5.Responses.title_not_correct_q02,
      text: Section5.Responses.text_q02,
    }
  },
  {
    ref: QstReferences.RefSection5Qst03,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.HasBonUsage,
    },
    is_correct: {
      title: Section5.Responses.title_correct_q03,
      text: Section5.Responses.text_correct_q03,
    },
    is_not_correct: {
      title: Section5.Responses.title_not_correct_q03,
      text: Section5.Responses.text_not_correct_q03,
    }
  },
  {
    ref: QstReferences.RefSection5Qst04,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.AMPlaiesChroniques,
    },
    is_correct: {
      title: Section5.Responses.title_correct_q04,
      text: Section5.Responses.text_q04,
    },
    is_not_correct: {
      title: Section5.Responses.title_not_correct_q04,
      text: Section5.Responses.text_q04,
    }
  },
  {
    ref: QstReferences.RefSection6Qst01,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.Snitem,
    },
    is_correct: {
      title: Section6.Responses.title_correct_q01,
      text: Section6.Responses.text_correct_q01,
    },
    is_not_correct: {
      title: Section6.Responses.title_not_correct_q01,
      text: Section6.Responses.text_not_correct_q01,
    }
  },
  {
    ref: QstReferences.RefSection6Qst02,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.Codims,
    },
    is_correct: {
      title: Section6.Responses.title_correct_q02,
    },
    is_not_correct: {
      title: Section6.Responses.title_not_correct_q02,
      text: Section6.Responses.text_not_correct_q02,
    }
  },
  {
    ref: QstReferences.RefSection6Qst03,
    type: RespTypes.Default,
    annexes: Section6.Responses.annexes_q03,
    small_texts: {
      1: SmallTexts.NoticesUtilisation,
    },
    is_correct: {
      title: Section6.Responses.title_correct_q03,
      text: Section6.Responses.text_q03,
    },
    is_not_correct: {
      title: Section6.Responses.title_not_correct_q03,
      text: Section6.Responses.text_q03,
    }
  },
  {
    ref: QstReferences.RefSection6Qst04,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.SenetP,
    },
    is_correct: {
      title: Section6.Responses.title_correct_q04,
    },
    is_not_correct: {
      title: Section6.Responses.title_not_correct_q04,
      text: Section6.Responses.text_not_correct_q04,
    }
  },
  {
    ref: QstReferences.RefSection6Qst05,
    type: RespTypes.Default,
    small_texts: {
      1: SmallTexts.MalacarneS,
      2: SmallTexts.AMPlaiesChroniques,
    },
    is_correct: {
      title: Section6.Responses.title_correct_q05,
    },
    is_not_correct: {
      title: Section6.Responses.title_not_correct_q05,
      text: Section6.Responses.text_not_correct_q05,
    }
  }
];

export const DataEndStats = [
  {
    ref: EndReferences.RefSection1End01,
    has_stars_note: true,
    is_correct: {
      title: Section1.EndTexts.title_correct_end01,
      text: Section1.EndTexts.text_correct_end01,
    },
    is_not_correct: {
      title: Section1.EndTexts.title_not_correct_end01,
      text: Section1.EndTexts.text_not_correct_end01,
    }
  },
  {
    ref: EndReferences.RefSection2End01,
    is_correct: {
      title: Section2.EndTexts.title_end01,
      text: Section2.EndTexts.text_end01,
    },
    is_not_correct: {
      title: Section2.EndTexts.title_end01,
      text: Section2.EndTexts.text_end01,
    }
  },
  {
    ref: EndReferences.RefSection3End01,
    is_correct: {
      title: Section3.EndTexts.title_end01,
      text: Section3.EndTexts.text_end01_p01 + '<br/><br/>' + Section3.EndTexts.text_end01_p02,
    },
    is_not_correct: {
      title: Section3.EndTexts.title_end01,
      text: Section3.EndTexts.text_end01_p01 + '<br/><br/>' + Section3.EndTexts.text_end01_p02,
    }
  },
  {
    ref: EndReferences.RefSection4End01,
    is_correct: {
      image: Section4.EndTexts.image_end01,
      title: Section4.EndTexts.title_end01,
      text: Section4.EndTexts.text_end01_p01 //+ '<br/><br/>' + Section3.EndTexts.text_end01_p02,
    },
    is_not_correct: {
      image: Section4.EndTexts.image_end01,
      title: Section4.EndTexts.title_end01,
      text: Section4.EndTexts.text_end01_p01 //+ '<br/><br/>' + Section3.EndTexts.text_end01_p02,
    }
  },
  {
    ref: EndReferences.RefSection5End01,
    is_correct: {
      image: Section5.EndTexts.image_end01,
      title: Section5.EndTexts.title_end01,
      text: Section5.EndTexts.text_end01_p01 + '<br/><br/>' + Section5.EndTexts.text_end01_p02 + '<br/><br/>' + Section5.EndTexts.text_end01_p03,
    },
    is_not_correct: {
      image: Section5.EndTexts.image_end01,
      title: Section5.EndTexts.title_end01,
      text: Section5.EndTexts.text_end01_p01 + '<br/><br/>' + Section5.EndTexts.text_end01_p02 + '<br/><br/>' + Section5.EndTexts.text_end01_p03,
    }
  },
  {
    ref: EndReferences.RefSection6End01,
    has_stars_note: true,
    is_correct: {
      title: Section6.EndTexts.title_correct_end01,
      text: Section6.EndTexts.text_correct_end01,
    },
    is_not_correct: {
      title: Section6.EndTexts.title_not_correct_end01,
      text: Section6.EndTexts.text_not_correct_end01,
    }
  },
  {
    ref: EndReferences.RefSection6End02,
    is_correct: {
      title: Section6.EndTexts.title_end02,
      text: Section6.EndTexts.text_end02,
    },
    is_not_correct: {
      title: Section6.EndTexts.title_end02,
      text: Section6.EndTexts.text_end02,
    }
  }
]
